import React, { useEffect, useState } from "react";
import AudioStreamMeter from "audio-stream-meter";
import { LocalAudioTrack } from "twilio-video";
import styles from "./AudioLevelMeter.module.css";
import { useIsMountedRef } from "hooks/useIsMountedRef";

interface AudioLevelMeterProps {
  audioTrack: LocalAudioTrack;
}
const AudioContext = window.AudioContext || (window as any).webkitAudioContext;

export const AudioLevelMeter: React.FC<AudioLevelMeterProps> = ({
  audioTrack,
}) => {
  const isMountedRef = useIsMountedRef();
  const [audioContext, setAudioContext] = useState<AudioContext>();
  const [, setMeter] = useState<any>();
  const [pct, setPct] = useState(0);

  useEffect(() => {
    if (isMountedRef.current && !audioContext) {
      setAudioContext(AudioContext ? new AudioContext() : undefined);
    }
  }, [audioContext, isMountedRef]);

  useEffect(() => {
    if (audioContext) {
      let stream = new MediaStream([audioTrack.mediaStreamTrack]);

      const mediaStream = audioContext.createMediaStreamSource(stream);
      const audioMeter = AudioStreamMeter.audioStreamProcessor(
        audioContext,
        () => {
          if (isMountedRef.current) {
            setPct(audioMeter.volume * 200);
          }
        }
      );
      mediaStream.connect(audioMeter);
      setMeter(audioMeter);
    }

    return () => {
      setMeter((prev: any) => {
        prev?.close();
      });
    };
  }, [audioTrack, audioContext, isMountedRef]);

  return (
    <>
      <div
        className={`${styles["volume-meter"]}`}
        style={{
          backgroundImage: `linear-gradient(to bottom, transparent ${
            100 - (pct > 100 ? 100 : pct)
          }%, #47cf73 ${100 - (pct > 100 ? 100 : pct)}%`,
        }}
      ></div>
    </>
  );
};
